var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-main",
    { staticClass: "blue-grey lighten-4" },
    [
      _c(
        "v-container",
        {
          staticStyle: {
            "{\n          display": "flex",
            "justify-content": "center",
            "align-items": "center",
            height: "100vh",
          },
          attrs: { fluid: "" },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }